<template>
<ViskaseCard>
    <template v-slot:header>
    </template>
    <template v-slot:title>
    </template>
    <template v-slot:default>
        <div class="row justify-content-start align-items-center p-2">
            <div class="col-12">
                <div v-html="for_text" class="fw-bold h2 pb-2">
                </div>
            </div>
            <div class="col-12 col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 col-xxl-5 text-start">
                <div> <img :src="selectedCasing.intro" class="img-responsive" style="width: 100%;" /></div>
            </div>
            <div class="col-12 col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 col-xxl-7 text-start align-items-center">
                <div>
                    <div v-if="selectedCasing.advantages.length" class="row align-items-center">
                        <div class="col-12">
                            <span v-html="advantages" class="fw-bold"> </span>
                            <ul>
                                <li v-for="(item, index) in selectedCasing.advantages" :key="index">
                                    {{ item.desc }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="selectedCasing.reasons.length" class="row align-items-center">
                        <div class="col-12">
                            <span v-html="reasons_to_use" class="fw-bold"> </span>
                            <ul>
                                <li v-for="(item, index) in selectedCasing.reasons" :key="index">
                                    {{ item.desc }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div> 
            <div class="col-12 col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 col-xxl-7 text-start pt-0">
                <div v-html="summary" class="fw-bold pt-2 h4">
                </div>
                <div v-if="selectedCasing.details.size">
                    <span class="fw-bold">{{size_range}}</span> {{ selectedCasing.details.size }}
                </div>
                <div v-if="selectedCasing.details.format">
                    <span class="fw-bold">{{finishing_formats}}</span> {{ selectedCasing.details.format }}
                </div>
                <div v-if="selectedCasing.details.printing">
                    <span class="fw-bold">{{printing}}:</span> {{ selectedCasing.details.printing }}
                </div>
                <div v-if="selectedCasing.details.color">
                    <span class="fw-bold">{{color}}</span> {{ selectedCasing.details.color }}
                </div>
                <div v-if="selectedCasing.details.colors">
                    <span class="fw-bold">{{colors}}</span> {{ selectedCasing.details.colors }}
                </div>
                <div v-if="selectedCasing.details.smoke">
                    <span class="fw-bold">{{smoke}}</span> {{ selectedCasing.details.smoke }}
                </div>
                <div v-if="selectedCasing.details.life">
                    <span class="fw-bold">{{shelf_life}}</span> {{ selectedCasing.details.life }}
                </div>
                <div v-if="selectedCasing.details.adhesion">
                    <span class="fw-bold">{{adhesion}}</span> {{ selectedCasing.details.adhesion }}
                </div>
                <div v-if="selectedCasing.details.treatments">
                    <span class="fw-bold">{{treatments}}</span> {{ selectedCasing.details.treatments }}
                </div>
                <div v-if="selectedCasing.details.color_smoke">
                    <span class="fw-bold">{{color_and_smoke}}</span> {{ selectedCasing.details.color_smoke }}
                </div>
                <div v-if="selectedCasing.details.eco">
                    <span class="fw-bold">{{eco}}</span> {{ selectedCasing.details.eco }}
                </div>
            </div>
            <div class="col-12 col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 col-xxl-56 text-start">
                <img :src="selectedCasing.summary" class="img-responsive" style="width: 100%;" />
            </div>
            <div class="col-12">
                <div class="p-2" v-for="item in selectedCasing.extras" :key="item.id">
                    <ViskaseFeatureTile :attributes="item.attributes" :img="item.img" :desc="item.desc" :title="item.title" :variant="item.variant" />
                </div>
            </div>
            <div class="col-12">
                <div v-html="design_your" class="fw-bold py-2 h4">
                </div>
                <div v-for="item in selectedCasing.features" :key="item.id">
                    <ViskaseFeatureTile :attributes="item.attributes" :img="item.img" :desc="item.desc" :title="item.title" :variant="item.variant" />
                </div>
            </div>
        </div>
    </template>
</ViskaseCard>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ViskaseCard from "@/components/core/ViskaseCard.vue";
import ViskaseFeatureTile from "@/components/core/ViskaseFeatureTile.vue";
export default {
  name: "Features",
  components: {
    ViskaseCard,
    ViskaseFeatureTile,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    ...mapMutations([]),
  },
  computed: {
    ...mapState(["selectedSolution", "selectedCasing", "cards"]),
    reasons_to_use() {
      return this.cards.features.reasons_to_use;
    },
    advantages() {
      return this.cards.features.advantages;
    },
    design_your() {
      return this.cards.features.design_your.replace(
        /{selectedCasing}/g,
        "<span class='viskase-orange-text fw-bold'>" +
          (this.selectedCasing || {}).title +
          "</span>"
      );
    },
    summary() {
      return this.cards.features.summary
        .replace(
          /{selectedCasing}/g,
          "<span class='viskase-orange-text fw-bold'>" +
            (this.selectedCasing || {}).title +
            "</span>"
        )
        .replace(
          /{selectedSolution}/g,
          "<span class='viskase-orange-text fw-bold'>" +
            (this.selectedSolution || {}).title +
            "</span>"
        );
    },
    for_text() {
      return this.cards.features.for_text
        .replace(
          /{selectedCasing}/g,
          "<span class='viskase-orange-text fw-bold'>" +
            (this.selectedCasing || {}).title +
            "</span>"
        )
        .replace(
          /{selectedSolution}/g,
          "<span class='viskase-orange-text fw-bold'>" +
            (this.selectedSolution || {}).title +
            "</span>"
        );
    },
    size_range() {
      return this.cards.features.size_range;
    },
    eco() {
      return this.cards.features.eco;
    },

    finishing_formats() {
      return this.cards.features.finishing_formats;
    },
    printing() {
      return this.cards.features.printing;
    },
    color() {
      return this.cards.features.color;
    },
    colors() {
      return this.cards.features.colors;
    },
    smoke() {
      return this.cards.features.smoke;
    },
    shelf_life() {
      return this.cards.features.shelf_life;
    },
    adhesion() {
      return this.cards.features.adhesion;
    },
    treatments() {
      return this.cards.features.treatments;
    },
    color_and_smoke() {
      return this.cards.features.color_and_smoke;
    },
  },
};
</script>

<style scoped>
</style>
